import { render, staticRenderFns } from "./Scadenziario.vue?vue&type=template&id=c0374a04"
import script from "./Scadenziario.vue?vue&type=script&lang=js"
export * from "./Scadenziario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports